import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import('./base.scss');

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
